import Slider from "react-slick";
import moment from "moment/moment";
import {Form, Formik} from "formik";
import {toast} from "react-toastify";
import React, {useEffect, useState} from "react";
import ToastContent from "../../../../components/toastContent";
import {validateCurrency} from "../../../../services/validate";
import ApiPlannings from "../../../../services/planning";
import {BaSeCheckbox, BaSeDatePicker, BaSeIcon, BaSeInput, BaSeOptionPicker,} from "@base/react";
import {
  addMonths,
  areDatesEqualIgnoringTime,
  eventTag,
  firstDayOfMonth,
  formatCurrency,
  formatDateToYearMonthString,
  formatFloat,
  formatMonthAndYearName,
  formatMonthAndYearNameToDate,
  formatYearAndMonthNameToDate,
  formatYearMonthToFullDate,
  generateDateRange,
  getPeriodString,
  maskFloat,
  maskMoney,
  reorderEntriesBySections,
  sortByMonthAndIgnoreEmpty,
  uuid,
} from "../../../../services/utils";
import InputSelect from "../../../../components/select";
import Button from "../../../../components/button/button";
import {MonthsQuantity, StepsModal, StepsYesOrNot,} from "../../../../mocks/default";
import StepComponent from "../../../../components/step-component";
import ModalDefault from "../../../../components/modals/modal-default";
import Input from "../../../../components/input";
import FampeInputRange from "../../../../components/fampe-input-range";
import Dialog from "../../../../components/dialog";
import Clock from "../../../../assets/images/icons/clock.svg";
import Wallet from "../../../../assets/images/icons/wallet.svg";
import Calendar from "../../../../assets/images/icons/calendar.svg";
import MoneyBox from "../../../../assets/images/icons/money-box.svg";
import BlueCard from "../../../../assets/images/icons/blue-card.svg";
import CashBill from "../../../../assets/images/icons/cash-bill.svg";
import Percentage from "../../../../assets/images/icons/percentage.svg";
import DollarSign from "../../../../assets/images/icons/dollar-sign.svg";
import ArrowUp from "../../../../assets/images/icons/circled-arrow-up.svg";
import ArrowDown from "../../../../assets/images/icons/circled-arrow-down.svg";
import BlueShakeHands from "../../../../assets/images/icons/blue-shakehands.svg";
import Loading from "../../../../components/loading";

const apiPlannings = ApiPlannings();

const periods = () => {
  const periods = [];
  const maxPeriods = 120;

  for (let p = 1; p <= maxPeriods; p++) {
    periods.push({
      id: p,
      label: `${p} ${p > 1 ? "meses" : "mês"}`,
    });
  }

  return periods;
};

const ProjectedCashFlow = ({
                             data,
                             results = null,
                             isDisabled,
                             onChange,
                             planId,
                             isStep9,
                             forceUpdateForm,
                             event,
                           }) => {
  const sortSaidasChronologically = (saidas) => {
    return [...saidas].sort((a, b) => {
      const dateA = new Date(a.mes + "-01");
      const dateB = new Date(b.mes + "-01");
      return dateA - dateB;
    });
  };

  const [calculatedValues, setCalculatedValues] = useState({
    val: 0,
    vfe: 0,
    vfp: 0,
    sdpc: 0,
    tjp: 0,
    cca: 0,
    ioft: 0,
  });
  const [localData, setLocalData] = useState(data);
  const [originalFormData, setOriginalFormData] = useState(null);
  const [fluxgraphUpdated, setFluxgraphUpdated] = useState(results);
  const [editId, setEditId] = useState(null);
  const [exitType, setExitType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [smallLoading, setSmallLoading] = useState(false);
  const [newCreditModalForm, setNewCreditModalForm] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isNewCredit, setIsNewCredit] = useState(false);
  const [calendarType, setCalendarType] = useState("days");
  const [stepActive, setStepActive] = useState(0);
  const [stepFampe, setStepFampe] = useState(1);
  const [isFampe, setIsFampe] = useState(false);
  const [showModal, setShowModal] = useState({
    status: false,
    type: "create",
    context: null,
  });
  const [initialBalance, setInitialBalance] = useState(false);
  const [showDialogConfirm, setShowDialogConfirm] = useState(false);
  const dataContent =
    localData && Object.values(localData).length > 0
      ? {
        ...localData,
        saidas: sortSaidasChronologically(localData.saidas || []),
      }
      : {
        mesBase: firstDayOfMonth(new Date()),
        saldoInicial: 0,
        saidas: [],
      };

  const [form, setForm] = useState({
    mesBase: dataContent.mesBase.length
      ? formatYearAndMonthNameToDate(dataContent.mesBase)
      : firstDayOfMonth(new Date()),
    saldoInicial: formatCurrency(dataContent.saldoInicial) || 0,
  });
  const formAddExitDefault = {
    uuid: uuid(),
    title: null,
    vcs: "0,00",
    tjm: "",
    qpm: "",
    pc: "",
    com_fampe: false,
    pf: 80,
    different: false,
    startMonth: dataContent.mesBase.length
      ? formatYearAndMonthNameToDate(dataContent.mesBase)
      : firstDayOfMonth(new Date()),
    endMonth: null,
    numberOfMonths: 1,
    fields: [
      {
        label: "Valor das parcelas",
        val: 0,
      },
    ],
  };
  const [showDetailsOutput, setShowDetailsOutput] = useState(true);
  const [showDetailsCashFlow, setShowDetailsCashFlow] = useState(true);
  const [formAddExit, setFormAddExit] = useState(formAddExitDefault);
  const [filterExit, setFilterExit] = useState("");
  const SettingsSliderCashFlow = {
    dots: dataContent?.saidas.length >= 1,
    infinite: false,
    speed: 500,
    slidesToShow: dataContent?.saidas.length
      ? dataContent?.saidas.filter((item) =>
        filterExit.length ? item.mes === filterExit : true
      ).length >= 2
        ? 3
        : dataContent?.saidas.length
      : 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    fade: false,
    centerMode: false,
    adaptiveHeight: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: dataContent?.saidas.length
            ? dataContent?.saidas.length >= 2
              ? 2
              : dataContent?.saidas.length
            : 1,
          centerMode: false,
          centerPadding: "16",
          variableWidth: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "16",
          variableWidth: false,
        },
      },
    ],
  };

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const getExits = async () => {
    setIsLoading(true);

    try {
      const refreshed = await apiPlannings.getPlanning(planId);

      setLocalData(refreshed.data.data.fluxo ?? refreshed.data.data);
      setFluxgraphUpdated(refreshed.data.results);
    } catch (error) {
      console.error("Erro", error);
      toast.error(
        <ToastContent
          description="Problema ao listar sua Capacidade de Pagamento, tente novamente"
          title="Erro!"
        />
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isStep9 === 9 && localData) {
      getExits();
    }
  }, [isStep9]);
  useEffect(() => {
    const isAnyOpen = showModal.status || newCreditModalForm;

    if (!isAnyOpen) {
      setFormAddExit(formAddExitDefault);
      setCalculatedValues({
        val: 0,
        vfe: 0,
        vfp: 0,
        sdpc: 0,
        tjp: 0,
        cca: 0,
        ioft: 0,
      });
      setIsFampe(false);
      setStepFampe(1);
      setEditId(null);
      setOriginalFormData(null);
      setExitType(null);
    }
  }, [showModal.status, newCreditModalForm]);

  const validateNewCreditNo = () => {
    const {
      title,
      vcs,
      amortizacao,
      pc,
      tjm,
      startMonth,
      endMonth,
      numberOfMonths,
    } = formAddExit;

    const showToast = (message) => {
      toast.warning(<ToastContent title="Atenção!" description={message} />);
    };

    if (!title || title.trim() === "") {
      showToast("Por favor, insira um nome para a saída.");
      return false;
    }

    const vcsNumber = Number((vcs || "").toString().replace(/\D/g, ""));
    if (!vcsNumber || vcsNumber <= 0) {
      showToast("Informe o valor de crédito solicitado.");
      return false;
    }

    if (!amortizacao) {
      showToast("Selecione o sistema de amortização.");
      return false;
    }

    if (!pc || Number(pc) <= 0) {
      showToast("Selecione o prazo de carência.");
      return false;
    }

    if (!tjm || Number(tjm) <= 0) {
      showToast("Informe a taxa de juros mensal.");
      return false;
    }

    if (calendarType === "months") {
      if (!numberOfMonths || Number(numberOfMonths) <= 0) {
        showToast("Selecione a quantidade de meses.");
        return false;
      }

      if (!startMonth) {
        showToast("Selecione a data inicial.");
        return false;
      }
    } else {
      if (!startMonth) {
        showToast("Selecione a data inicial.");
        return false;
      }

      if (!endMonth) {
        showToast("Selecione a data final.");
        return false;
      }
    }

    if (isFampe && (!formAddExit.pf || Number(formAddExit.pf) <= 0)) {
      showToast("Informe a porcentagem de garantia FAMPE.");
      return false;
    }

    return true;
  };
  const validateVigenteOrYNC = () => {
    const { title, startMonth, endMonth, numberOfMonths, fields, different } =
      formAddExit;

    const showToast = (message) => {
      toast.warning(<ToastContent title="Atenção!" description={message} />);
    };

    if (!title || title.trim() === "") {
      showToast("Por favor, insira um nome para a saída.");
      return false;
    }

    if (calendarType === "months") {
      if (!numberOfMonths || Number(numberOfMonths) <= 0) {
        showToast("Selecione a quantidade de meses.");
        return false;
      }
    } else {
      if (!startMonth) {
        showToast("Selecione o mês inicial.");
        return false;
      }

      if (!endMonth) {
        showToast("Selecione o mês final.");
        return false;
      }
    }

    if (different) {
      const emptyVal = fields.some(
        (f) => f.val === "" || f.val === null || f.val === undefined
      );

      if (emptyVal) {
        showToast("Preencha todos os valores mensais antes de salvar.");
        return false;
      }
    } else {
      const firstVal = fields[0]?.val;
      if (firstVal === "" || firstVal === null || firstVal === undefined) {
        showToast("Informe o valor principal da saída.");
        return false;
      }
    }

    return true;
  };
  const handleFampeChoice = (value, index) => {
    setIsFampe(value);
    setStepFampe(index);
    eventTag(event?.name, event?.category, event?.action, `Operação com FAMPE - ${value ? 'Sim' : 'Não'}`)
  };
  const changeTabs = (type, active) => {
    setStepActive(active);
    setCalendarType(type);

    if (type === "days") {
      setFormAddExit((prevForm) => syncEndMonthWithGracePeriod(prevForm));
    }
  };
  const updateField = (index, newValue) => {
    setFormAddExit((prevState) => {
      const updatedFields = [...prevState.fields];
      updatedFields[index] = { ...updatedFields[index], val: newValue };
      return {
        ...prevState,
        fields: updatedFields,
      };
    });
  };
  const formatData = (input) => {
    const { uuid, title, different, startMonth, endMonth, fields } = input;
    const dateRange = generateDateRange(startMonth, endMonth);

    const formattedFields = dateRange.map((date, index) => {
      return {
        [date]: different ? fields[index]?.val : fields[0]?.val,
      };
    });
    return {
      [uuid]: {
        title,
        different,
        fields: formattedFields,
      },
    };
  };
  const protectWhileDeleting = (callback) => {
    if (deletingId !== null) {
      toast.warning(
        <ToastContent
          description="Você não pode fazer essa ação enquanto uma saída está sendo excluída"
          title="Aguarde!"
        />
      );
      return;
    }

    callback();
  };
  const formatReverseData = (input) => {
    const [uuid, data] = Object.entries(input)[0];
    const { title, different, fields } = data;

    const parsedFields = fields.map((field) => {
      // eslint-disable-next-line
      const [key, val] = Object.entries(field)[0];
      return { label: "Valor das parcelas", val };
    });

    const dateKeys = fields.map((field) => Object.keys(field)[0]);
    const startMonth = formatMonthAndYearNameToDate(dateKeys[0]);
    const endMonth = formatMonthAndYearNameToDate(dateKeys.at(-1));
    const numberOfMonths = dateKeys.length;

    return {
      uuid,
      title,
      different: !!different,
      startMonth: startMonth,
      endMonth: endMonth,
      numberOfMonths,
      fields: parsedFields,
    };
  };
  const formatFieldsCheckDifferentValues = () => {
    const { different, startMonth, endMonth, fields } = formAddExit;
    const dateRange = generateDateRange(startMonth, endMonth);
    let modifiedFields = [
      {
        label: "Valor das parcelas",
        val: fields[0]?.val || 0,
      },
    ];
    if (different) {
      modifiedFields = dateRange.map((date, index) => ({
        label: `Valor ${date}`,
        val: fields[index]?.val || 0,
      }));
    }

    return {
      ...formAddExit,
      fields: modifiedFields,
    };
  };
  const getGracePeriodEndMonth = (startMonth, pc) => {
    if (!startMonth || !pc || Number(pc) <= 0) return null;

    return addMonths(startMonth, Number(pc));
  };
  const isBeforeMonth = (date, referenceDate) => {
    if (!date || !referenceDate) return false;

    const month = firstDayOfMonth(date);
    const referenceMonth = firstDayOfMonth(referenceDate);

    return month < referenceMonth;
  };
  const getMonthsBetweenDates = (startMonth, endMonth) => {
    if (!startMonth || !endMonth) return null;

    const start = firstDayOfMonth(startMonth);
    const end = firstDayOfMonth(endMonth);

    return (
      (end.getFullYear() - start.getFullYear()) * 12 +
      end.getMonth() -
      start.getMonth()
    );
  };
  const syncEndMonthWithGracePeriod = (formData) => {
    const gracePeriodEndMonth = getGracePeriodEndMonth(
      formData.startMonth,
      formData.pc
    );

    if (
      !gracePeriodEndMonth ||
      (formData.endMonth &&
        !isBeforeMonth(formData.endMonth, gracePeriodEndMonth))
    ) {
      return formData;
    }

    return {
      ...formData,
      endMonth: gracePeriodEndMonth,
      numberOfMonths: generateDateRange(
        formData.startMonth,
        gracePeriodEndMonth
      ).length,
    };
  };
  const updateNewCreditNoGracePeriod = (value) => {
    setFormAddExit((prevForm) => {
      const nextForm = {
        ...prevForm,
        pc: value,
      };

      return calendarType === "days"
        ? syncEndMonthWithGracePeriod(nextForm)
        : nextForm;
    });
  };
  const updateNewCreditNoStartMonth = (value) => {
    setFormAddExit((prevForm) => {
      const nextForm = (() => {
        if (calendarType === "months") {
          return {
            ...prevForm,
            startMonth: value,
            endMonth: prevForm.numberOfMonths
              ? addMonths(value, prevForm.numberOfMonths - 1)
              : null,
          };
        }

        if (prevForm.endMonth && value > prevForm.endMonth) {
          return {
            ...prevForm,
            startMonth: value,
            endMonth: null,
            numberOfMonths: 1,
          };
        }

        return {
          ...prevForm,
          startMonth: value,
          numberOfMonths: generateDateRange(value, prevForm.endMonth).length,
        };
      })();

      return calendarType === "days"
        ? syncEndMonthWithGracePeriod(nextForm)
        : nextForm;
    });
  };
  const updateNewCreditNoEndMonth = (value) => {
    setFormAddExit((prevForm) => {
      const monthsBetweenDates = getMonthsBetweenDates(
        prevForm.startMonth,
        value
      );
      const pc =
        calendarType === "days" &&
        monthsBetweenDates >= 1 &&
        monthsBetweenDates <= MonthsQuantity.length
          ? String(monthsBetweenDates)
          : prevForm.pc;

      return {
        ...prevForm,
        pc,
        endMonth: value,
        numberOfMonths: generateDateRange(prevForm.startMonth, value).length,
      };
    });
  };
  const updateStartEndDate = (type, value) => {
    setFormAddExit((prevForm) => {
      const { startMonth, endMonth } = prevForm;

      if (type === "select") {
        return {
          ...prevForm,
          numberOfMonths: value,
          endMonth: addMonths(startMonth, value - 1),
        };
      }

      if (type === "start") {
        if (calendarType === "months") {
          return {
            ...prevForm,
            startMonth: value,
            endMonth: prevForm.numberOfMonths
              ? addMonths(value, prevForm.numberOfMonths - 1)
              : null,
          };
        }

        if (endMonth && value > endMonth) {
          return {
            ...prevForm,
            startMonth: value,
            endMonth: null,
            numberOfMonths: 1,
          };
        }

        return {
          ...prevForm,
          startMonth: value,
          numberOfMonths: generateDateRange(value, endMonth).length,
        };
      }

      if (type === "end") {
        return {
          ...prevForm,
          endMonth: value,
          numberOfMonths: generateDateRange(startMonth, value).length,
        };
      }

      return prevForm;
    });
  };
  const normalizeNumber = (value) => {
    if (value === null || value === undefined || value === "") return null;

    const str = String(value);
    return Number(str.replace(/\./g, "").replace(",", "."));
  };
  const mergeDataModalIntoSaidas = (dataModal) => {
    const result = { ...dataContent };
    const uuid = Object.keys(dataModal)[0];
    const modalEntry = dataModal[uuid];

    for (const saida of result.saidas) {
      saida.entries = saida.entries.filter((entry) => entry.uuid !== uuid);
    }

    result.saidas = result.saidas.filter((saida) => saida.entries.length > 0);

    for (const field of modalEntry.fields) {
      const [mes, ano] = Object.keys(field)[0].split("-");
      const fullDate = `${ano}-${mes}`;
      const val = field[`${mes}-${ano}`];
      let saida = result.saidas.find((saida) => saida.mes === fullDate);

      if (!saida) {
        saida = { mes: fullDate, entries: [] };
        result.saidas.push(saida);
      }

      saida.entries.push({
        uuid: uuid,
        title: modalEntry.title,
        val: formatFloat(val),
        different: modalEntry.different,
      });
    }

    return result.saidas;
  };
  function formatYearMonth(dateStr) {
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  }

  // Função que está permitindo atualizar as informações sem fechar o modal
  const loadNewCreditNoEntry = (refreshed, identifier) => {
    const allSaidas =
      refreshed.data.fluxo?.saidas ?? refreshed.data.saidas ?? [];

    let entryFound = null;

    for (const saida of allSaidas) {
      for (const entry of saida.entries) {
        const match =
          entry.type === "credito-novo-nao" &&
          (entry.id === identifier || entry.title === identifier);

        if (match) {
          entryFound = entry;
          break;
        }
      }
      if (entryFound) break;
    }

    if (!entryFound) return;

    setEditId(entryFound.id);
    setExitType("newCreditNo");

    setFormAddExit({
      ...formAddExitDefault,
      title: entryFound.title,
      vcs: String(Math.round((entryFound.vcs ?? 0) * 100)),
      tjm: String(entryFound.tjm ?? ""),
      pc: String(entryFound.pc ?? ""),
      amortizacao: entryFound.amortizacao ?? "tabela_price",
      startMonth: parseYearMonth(entryFound.data_inicial),
      endMonth: parseYearMonth(entryFound.data_final),
      numberOfMonths: entryFound.qpm ?? 1,
      pf: entryFound.pf ?? 80,
      com_fampe: entryFound.com_fampe ?? false,
    });

    setCalculatedValues({
      val: entryFound.val ?? 0,
      vfe: entryFound.vfe ?? 0,
      vfp: entryFound.vfp ?? 0,
      sdpc: entryFound.sdpc ?? 0,
      tjp: entryFound.tjp ?? 0,
      cca: entryFound.cca ?? 0,
      ioft: entryFound.ioft ?? 0,
    });

    setIsFampe(entryFound.com_fampe);
    setStepFampe(entryFound.com_fampe ? 0 : 1);

    setNewCreditModalForm(true);
  };

  // Requisições - Fluxo de Caixa Projetado
  const saveDialogAddExit = async (
    formType,
    action = "post",
    exits = null,
    editId = null,
    forcedType = null
  ) => {
    const isLegacy = !editId;
    let dataModalAddExit;
    let dataModalInitialBalance;
    let mergeDataIntoSaidas;

    if (isLegacy) {
      dataModalAddExit = formatData(formAddExit);
      dataModalInitialBalance = form;
      mergeDataIntoSaidas = mergeDataModalIntoSaidas(dataModalAddExit);
    }

    let payload;

    const useSmallLoading = formType === "newCreditNo" || action === "delete";

    // Se for Endividamento Vigente ou Credito novo sim
    if (formType === "vigenteOrYNC") {
      // Se for parcelas diferentes
      if (formAddExit.different) {
        payload = {
          plan: planId,
          title: formAddExit.title,
          different_values: formAddExit.fields.map((field) => {
            const date = field.label.replace("Valor ", "");
            return {
              val: normalizeNumber(field.val),
              date,
            };
          }),
        };
      } else {
        // Se for parcela única
        payload = {
          plan: planId,
          title: formAddExit.title,
          vdp: normalizeNumber(formAddExit.fields[0]?.val),
          qpm: Number(formAddExit.numberOfMonths),
          data_inicial: formatYearMonth(formAddExit.startMonth),
          data_final: formatYearMonth(formAddExit.endMonth),
        };
      }
    } else if (formType === "newCreditNo") {
      payload = {
        plan: planId,
        title: formAddExit.title,
        vcs: Number(formAddExit.vcs) / 100,
        tjm: Number(formAddExit.tjm),
        pc: Number(formAddExit.pc),
        amortizacao: formAddExit.amortizacao,
        com_fampe: stepFampe === 1 ? false : true,
        data_inicial: formatYearMonth(formAddExit.startMonth),
        pf: Number(formAddExit.pf),

        ...(stepActive === 0 && {
          data_final: formatYearMonth(formAddExit.endMonth),
        }),

        ...(stepActive === 1 && {
          qpm: Number(formAddExit.numberOfMonths),
        }),
      };
    }

    if (action === "delete" || action === "edit") {
      if (isLegacy) {
        onChange({
          mesBase: formatDateToYearMonthString(dataModalInitialBalance.mesBase),
          saldoInicial: formatFloat(dataModalInitialBalance.saldoInicial),
          saidas: sortByMonthAndIgnoreEmpty(exits || mergeDataIntoSaidas),
        });

        setInitialBalance(false);
        return;
      }
    }

    try {
      if (useSmallLoading) {
        setSmallLoading(true);
      } else {
        setIsLoading(true);
      }

      if (action === "edit" && editId && !isLegacy) {
        let finalPayloadForComparison = {};

        if (exitType === "newCreditNo") {
          finalPayloadForComparison = {
            title: formAddExit.title,
            vcs: Number(formAddExit.vcs) / 100,
            amortizacao: formAddExit.amortizacao,
            pc: Number(formAddExit.pc),
            tjm: Number(formAddExit.tjm),
            data_inicial: formatYearMonth(formAddExit.startMonth),
            pf: Number(formAddExit.pf),
            com_fampe: isFampe,

            ...(stepActive === 0 && {
              data_final: formatYearMonth(formAddExit.endMonth),
            }),

            ...(stepActive === 1 && {
              qpm: Number(formAddExit.numberOfMonths),
            }),
          };
        } else {
          const { plan, ...payloadWithoutPlan } = payload || {};
          finalPayloadForComparison = payloadWithoutPlan;
        }

        const payloadOnlyChanged = getChangedFields(
          originalFormData || {},
          finalPayloadForComparison
        );

        if (Object.keys(payloadOnlyChanged).length === 0) {
          toast.warning(
            <ToastContent
              title="Atenção!"
              description="Nenhuma mudança detectada."
            />
          );
          return;
        }

        const reqType =
          exitType === "existingDebt" ? "existing-debt" : "credit-simulations";
        await apiPlannings.updateOutput(editId, payloadOnlyChanged, reqType);

        const refreshed = await forceUpdateForm();
        setLocalData(refreshed.data.fluxo ?? refreshed.data);
        setFluxgraphUpdated(refreshed.results);
        loadNewCreditNoEntry(refreshed, payload.title);
        eventTag(event?.name, event?.category, "submit", "Editando saída")

      } else if (action === "delete" && editId && !isLegacy) {
        const reqType =
          forcedType === "endividamento"
            ? "existing-debt"
            : "credit-simulations";

        await apiPlannings.deleteOutput(editId, reqType);
        eventTag(event?.name, event?.category, "submit", "Removendo saída")
        const refreshed = await forceUpdateForm();
        setLocalData(refreshed.data.fluxo ?? refreshed.data);
        setFluxgraphUpdated(refreshed.results);
      } else {
        if (formType === "vigenteOrYNC") {
          if (exitType === "existingDebt") {
            await apiPlannings.createExistingDebt(payload);
            eventTag(event?.name, event?.category, "submit", "Criando endividamento vigente")
          } else if (exitType === "newCreditYes") {
            await apiPlannings.createCreditSimulation(payload);
            eventTag(event?.name, event?.category, "submit", "Criando crédito novo - Sim")
          }
        } else if (formType === "newCreditNo") {
          await apiPlannings.createCreditSimulation(payload);
          eventTag(event?.name, event?.category, "submit", "Criando crédito novo - Não")
        }
        const refreshed = await forceUpdateForm();
        setLocalData(refreshed.data.fluxo ?? refreshed.data);
        setFluxgraphUpdated(refreshed.results);
        loadNewCreditNoEntry(refreshed, payload.title);
      }

      setShowModal({ status: false, type: "create" });
      setInitialBalance(false);
    } catch (error) {
      console.error("Erro ao salvar:", error);

      const response = error;
      const status = response?.status;
      const details = response?.details;

      if (
        status === 400 &&
        details?.data_final &&
        Array.isArray(details.data_final)
      ) {
        toast.error(
          <ToastContent
            title="Erro!"
            description={details.data_final[0]}
          />
        );
        return;
      }

      toast.error(
        <ToastContent
          title="Erro!"
          description="Ocorreu um erro ao salvar. Tente novamente."
        />
      );
    } finally {
      if (useSmallLoading) {
        setSmallLoading(false);
        setDeletingId(null);
      } else {
        setIsLoading(false);
      }
    }
  };

  const extractSections = (data) => {
    const sections = [];

    for (const saida of data.saidas) {
      const { entries } = saida;

      for (const entry of entries) {
        const { uuid, title, id, type } = entry;
        const existing = sections.find((section) => section.sectionId === uuid);

        if (!existing) {
          sections.push({ title, type, sectionId: uuid, id });
        } else if (!existing.id && id) {
          existing.id = id;
        }
      }
    }

    return sections;
  };
  const generateDataModalForEdit = (targetUuid) => {
    const dataModal = {};

    for (const saida of dataContent.saidas) {
      const { mes, entries } = saida;

      const realEntries = (entries || []).filter(
        (item) => item.id && item.uuid === targetUuid
      );

      for (const entry of realEntries) {
        const { uuid, title, val, different, vcs, tjm, pc, amortizacao } =
          entry;
        const hasDifferentValues = Boolean(
          different || entry.different_values?.length
        );

        if (!dataModal[uuid]) {
          dataModal[uuid] = {
            title,
            different: hasDifferentValues,
            fields: [],
            vcs,
            tjm,
            pc,
            amortizacao,
            rawValues: [],
          };
        } else {
          dataModal[uuid].different =
            dataModal[uuid].different || hasDifferentValues;
        }

        dataModal[uuid].fields.push({
          [formatMonthAndYearName(mes)]: formatCurrency(val),
        });
        dataModal[uuid].rawValues.push(Number(val));
      }
    }

    Object.values(dataModal).forEach((entry) => {
      if (!entry.different && entry.rawValues.length > 1) {
        const [firstValue] = entry.rawValues;
        entry.different = entry.rawValues.some((value) => value !== firstValue);
      }

      delete entry.rawValues;
    });

    return dataModal;
  };

  const parseYearMonth = (str) => {
    if (!str) return null;

    const [year, month] = str.split("-").map(Number);

    return new Date(year, month - 1, 1);
  };

  const getChangedFields = (original, current) => {
    const changed = {};

    for (const key in current) {
      if (current[key] !== original[key]) {
        changed[key] = current[key];
      }
    }

    return changed;
  };

  const openDialogForEdit = (uuid, id) => {
    setEditId(id);

    let fullEntry = null;

    for (const saida of dataContent.saidas) {
      const realEntry = saida.entries.find(
        (entry) => entry.uuid === uuid && entry.id
      );
      if (realEntry) {
        fullEntry = realEntry;
        break;
      }
    }

    if (!fullEntry) {
      console.error("Entry não encontrado no dataContent para o uuid:", uuid);
      return;
    }

    if (fullEntry.type === "credito-novo-nao") {
      setExitType("newCreditNo");

      setFormAddExit({
        ...formAddExitDefault,
        title: fullEntry.title,
        vcs: String(Math.round((fullEntry.vcs ?? fullEntry.vdp ?? 0) * 100)),
        tjm: String(fullEntry.tjm ?? ""),
        pc: String(fullEntry.pc ?? ""),
        amortizacao: fullEntry.amortizacao ?? "tabela_price",

        startMonth: parseYearMonth(fullEntry.data_inicial),
        endMonth: parseYearMonth(fullEntry.data_final),
        numberOfMonths: fullEntry.qpm ?? 1,

        pf: fullEntry.pf ?? 80,
        com_fampe: fullEntry.com_fampe ?? false,
      });

      setOriginalFormData({
        title: fullEntry.title,
        vcs: fullEntry.vcs,
        amortizacao: fullEntry.amortizacao,
        pc: fullEntry.pc,
        tjm: fullEntry.tjm,
        qpm: fullEntry.qpm,
        data_inicial: fullEntry.data_inicial,
        data_final: fullEntry.data_final,
        pf: fullEntry.pf,
        com_fampe: fullEntry.com_fampe,
      });

      setCalculatedValues({
        val: fullEntry.val ?? 0,
        vfe: fullEntry.vfe ?? 0,
        vfp: fullEntry.vfp ?? 0,
        sdpc: fullEntry.sdpc ?? 0,
        tjp: fullEntry.tjp ?? 0,
        cca: fullEntry.cca ?? 0,
        ioft: fullEntry.ioft ?? 0,
      });

      setIsFampe(fullEntry.com_fampe);
      setStepFampe(fullEntry.com_fampe ? 0 : 1);

      setNewCreditModalForm(true);
      setShowModal({ ...showModal, status: false });
      return;
    }

    if (fullEntry.type === "endividamento") {
      setExitType("existingDebt");
    } else if (fullEntry.type === "credito-novo-sim") {
      setExitType("newCreditYes");
    }

    const dataEdit = generateDataModalForEdit(uuid);
    const formattedData = formatReverseData(dataEdit);
    const dataEditEntry = Object.values(dataEdit)[0];

    setFormAddExit(formattedData);

    if (formattedData.different) {
      // Diferentes parcelas
      setOriginalFormData({
        title: formattedData.title,
        different_values: dataEditEntry.fields.map((field) => {
          const [date, val] = Object.entries(field)[0];

          return {
            val: normalizeNumber(val),
            date,
          };
        }),
      });
    } else {
      // Parcela de valor único
      setOriginalFormData({
        title: formattedData.title,
        vdp: normalizeNumber(formattedData.fields[0]?.val),
        qpm: Number(formattedData.numberOfMonths),
        data_inicial: formatYearMonth(formattedData.startMonth),
        data_final: formatYearMonth(formattedData.endMonth),
      });
    }

    setShowModal({ status: true, type: "edit" });
  };

  const removeExitsById = (uuid, id, type) => {
    const isLegacy = !id;

    setDeletingId(id || uuid);

    if (isLegacy) {
      const newExists = dataContent?.saidas
        .map((item) => ({
          ...item,
          entries: item.entries.filter((entry) => entry.uuid !== uuid),
        }))
        .filter((item) => item.entries.length > 0);

      setEditId(null);
      saveDialogAddExit(null, "delete", newExists, null);
    } else {
      setEditId(id);
      saveDialogAddExit(null, "delete", null, id, type);
    }
  };
  const getMinEndDateByGracePeriod = (startMonth, pc) => {
    if (!startMonth) return null;

    const start = new Date(startMonth);
    const graceEnd = pc && Number(pc) > 0
      ? addMonths(start, Number(pc))
      : start;

    return graceEnd;
  };
  const filterArrayByDateRange = (array, mesBase, mesFinal) => {
    const filteredArray = array.filter((item) => {
      const itemDate = formatYearAndMonthNameToDate(item.mes);
      return itemDate >= mesBase && itemDate <= mesFinal;
    });
    return {
      isOutOfRange: filteredArray.length !== array.length,
      data: filteredArray,
    };
  };
  const getMonthBaseAndMore120Months = () => {
    const monthBase = form?.mesBase;
    const monthFinal = addMonths(form?.mesBase, 120);

    return {
      monthBase: monthBase,
      monthFinal: monthFinal,
    };
  };
  const addBalanceInitial = () => {
    if (isDisabled) return;

    eventTag(event?.name, event?.category, "submit", "Adicionando saldo inicial")
    onChange({
      mesBase: formatDateToYearMonthString(form.mesBase),
      saldoInicial: formatFloat(form.saldoInicial),
      saidas: dataContent?.saidas || [],
    });

    setInitialBalance(false);
  };
  const confirmChangeBalanceInitial = () => {
    const dataModalAddExit = formatData(formAddExit);
    const mergeDataIntoSaidas = mergeDataModalIntoSaidas(dataModalAddExit);
    const arrayExits = sortByMonthAndIgnoreEmpty(mergeDataIntoSaidas);
    const byDataRange = filterArrayByDateRange(
      arrayExits,
      getMonthBaseAndMore120Months().monthBase,
      getMonthBaseAndMore120Months().monthFinal
    );
    saveDialogAddExit(byDataRange.data);
  };

  const TemplateQuickView = () => {
    const exits = dataContent?.saidas.map((item, index) => {
      return {
        id: item.mes,
        label: `${index + 1} - ${formatYearMonthToFullDate(item.mes)}`,
      };
    });

    const toggleFilter = (value) => {
      setFilterExit(filterExit === value ? "" : value);
    };
    const clearFilter = () => {
      setFilterExit("");
      eventTag(event?.name, event?.category, event?.action, "Limpar filtro de visualização rápida")
    };

    return exits.length ? (
      <>
        <div className="cash-flow__quick-view mobile">
          <div className="wrapper-select">
            <BaSeOptionPicker
              label="Visualização rápida"
              values={exits}
              enableSelectAll={false}
              menuAlwaysIsOpen={false}
              withFilterText={false}
              emptyValueLabel="Selecione"
              maxOptionsSelected={1}
              initialSelectedValuesId={filterExit ? [filterExit] : []}
              onChange={(selectedValues) => {
                const selectedId = selectedValues?.[0]?.id ?? "";
                setFilterExit(selectedId)
                if (selectedId) {
                  eventTag(event?.name, event?.category, event?.action, `Visualização rápida - ${selectedValues?.[0]?.label || ''}`)
                }
              }}
            />
          </div>
          {filterExit.length ? (
            <div className="clear">
              <button
                className="link"
                type="button"
                onClick={() => clearFilter()}
              >
                Limpar
              </button>
            </div>
          ) : null}
        </div>
        <div className="cash-flow__quick-view desktop">
          <h6>Visualização rápida</h6>
          <div className="months">
            {exits.map((item, index) => (
              <button
                key={index}
                type="button"
                className={"month " + (filterExit === item.id ? "active" : "")}
                onClick={() => {
                  toggleFilter(item.id)
                  eventTag(event?.name, event?.category, event?.action, `Visualização rápida - ${item?.label}`)
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </>
    ) : null;
  };

  useEffect(() => {
    if (!showModal.status) {
      setFormAddExit(formAddExitDefault);
    }
    // eslint-disable-next-line
  }, [showModal]);
  useEffect(() => {
    setFormAddExit({ ...formAddExit, ...formatFieldsCheckDifferentValues() });
    // eslint-disable-next-line
  }, [formAddExit?.different, formAddExit?.startMonth, formAddExit?.endMonth]);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsNewCredit(option === "newCredit");
  };

  const OptionsAmortizacao = [
    {
      value: "tabela_price",
      label: "Tabela Price",
    },
  ];

  const typeMap = {};
  dataContent?.saidas?.forEach((saida) => {
    (saida.entries || []).forEach((entry) => {
      const baseUuid = entry.uuid.replace(/-\d+$/, "");
      if (!typeMap[baseUuid]) {
        typeMap[baseUuid] = entry.type;
      }
    });
  });

  useEffect(() => {
    if (!showModal.status && !newCreditModalForm) {
      setFormAddExit(formAddExitDefault);
      setEditId(null);
    }
  }, [showModal, newCreditModalForm]);

  return (
    <div className="step cash-flow">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <h3 className="cash-flow__title">Mês atual:</h3>
          <div className="wrapper-flux title">
            <p className="date">{moment().format("MMMM [de] YYYY")}</p>
          </div>

          <ModalDefault
            show={showOptionsModal}
            title="Adicionar saída"
            callBackClose={() => {
              setIsNewCredit(false);
              setSelectedOption(null);
              setShowOptionsModal(false);
              eventTag(event?.name, event?.category, event?.action, "Fechar modal - Adicionar saída")
            }}
          >
            <p>Como você caracteriza essa saída?</p>

            <div className="btns-area">
              <Button
                icon={Wallet}
                callback={() => {
                  setExitType("existingDebt");
                  setShowOptionsModal(false);
                  setTimeout(() => {
                    setShowModal({
                      status: true,
                      type: "create",
                      context: "vigente",
                    })
                  }, 200);
                  eventTag(event?.name, event?.category, event?.action, "Adicionar saída - Endividamento Vigente")
                }}
              >
                Endividamento Vigente
              </Button>

              <Button
                selected={selectedOption === "newCredit"}
                icon={MoneyBox}
                callback={() => {
                  handleSelect("newCredit")
                  eventTag(event?.name, event?.category, event?.action, "Adicionar saída - Crédito Novo")
                }}
              >
                Crédito Novo
              </Button>
            </div>

            <div className="new-credit-area">
              {isNewCredit && (
                <>
                  <p>Você já sabe os valores das parcelas do crédito novo?</p>
                  <div className="new-credit-area-buttons">
                    <Button
                      isPrimary={false}
                      maxWidth="100px"
                      callback={() => {
                        setIsNewCredit(false);
                        setSelectedOption(null);
                        setExitType("newCreditYes");
                        setShowOptionsModal(false);
                        setTimeout(() => {
                          setShowModal({
                            status: true,
                            type: "create",
                            context: "newCredit",
                          });
                        }, 200);
                        eventTag(event?.name, event?.category, event?.action, "Crédito Novo - Sim")
                      }}
                    >
                      Sim
                    </Button>
                    <Button
                      isPrimary={false}
                      maxWidth="100px"
                      callback={() => {
                        setIsNewCredit(false);
                        setSelectedOption(null);
                        setExitType("newCreditNo");
                        setShowOptionsModal(false);
                        setTimeout(() => {
                          setNewCreditModalForm(true);
                        }, 200);
                        eventTag(event?.name, event?.category, event?.action, "Crédito Novo - Não")
                      }}
                    >
                      Não
                    </Button>
                  </div>
                </>
              )}
            </div>
          </ModalDefault>

          <ModalDefault
            show={newCreditModalForm}
            title="Adicionar crédito novo"
            callBackClose={() => {
              setNewCreditModalForm(false)
              eventTag(event?.name, event?.category, event?.action, "Fechar modal - Adicionar crédito novo")
            }}
          >
            <Formik initialValues={form}>
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  {smallLoading ? (
                    <Loading />
                  ) : (
                    <>
                      <Input
                        title="Nome da saída"
                        placeholder="Escolha um nome para a saída"
                        value={formAddExit.title || ""}
                        onChange={(e) =>
                          setFormAddExit({
                            ...formAddExit,
                            title: e.target.value,
                          })
                        }
                      />

                      <div className="modal-second-section">
                        <Input
                          title="Valor de crédito solicitado"
                          placeholder="Valor em R$"
                          value={maskMoney(String(formAddExit.vcs || ""))}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, "");
                            setFormAddExit({
                              ...formAddExit,
                              vcs: raw,
                            });
                          }}
                        />

                        <InputSelect
                          value={formAddExit.amortizacao}
                          options={OptionsAmortizacao}
                          onChange={(value) =>
                            setFormAddExit({
                              ...formAddExit,
                              amortizacao: value,
                            })
                          }
                          title="Sistema de amortização"
                        />
                      </div>

                      <div className="modal-third-section">
                        <InputSelect
                          title="Prazo de Carência"
                          value={formAddExit.pc}
                          options={MonthsQuantity}
                          onChange={(value) =>
                            updateNewCreditNoGracePeriod(value)
                          }
                        />

                        <Input
                          title="Taxa de juros mensal (%)"
                          placeholder="Ex: 2.5"
                          value={formAddExit.tjm}
                          onChange={(e) => {
                            const masked = maskFloat(e.target.value);
                            setFormAddExit({ ...formAddExit, tjm: masked });
                          }}
                        />
                      </div>

                      <StepComponent
                        stepActive={stepActive}
                        filterType={changeTabs}
                        listSteps={StepsModal}
                      />

                      <div className="modal-fourth-section">
                        {calendarType === "days" ? (
                          <>
                            <BaSeDatePicker
                              calendarType="months"
                              startDate={formAddExit.startMonth}
                              maxDate={
                                calendarType === "months"
                                  ? formAddExit.endMonth
                                  : undefined
                              }
                              onStartDateChange={(e) =>
                                updateNewCreditNoStartMonth(e)
                              }
                              placeholder="Data de início"
                              label="Data inicial"
                              isDisabled={isDisabled}
                              minDate={formAddExitDefault.startMonth}
                            />

                            <BaSeDatePicker
                              calendarType="months"
                              startDate={formAddExit.endMonth}
                              onStartDateChange={(e) =>
                                updateNewCreditNoEndMonth(e)
                              }
                              placeholder="Data de término"
                              minDate={getMinEndDateByGracePeriod(
                                formAddExit.startMonth,
                                formAddExit.pc
                              )}
                              maxDate={
                                formAddExit.startMonth
                                  ? addMonths(
                                    new Date(formAddExit.startMonth),
                                    120
                                  )
                                  : undefined
                              }
                              label="Data final"
                              isDisabled={isDisabled || !formAddExit.startMonth}
                            />
                          </>
                        ) : (
                          <>
                            <InputSelect
                              title="Quantidade de meses"
                              value={formAddExit?.numberOfMonths}
                              options={periods().map((p) => ({
                                value: p.id,
                                label: p.label,
                              }))}
                              onChange={(value) =>
                                updateStartEndDate("select", value)
                              }
                            />

                            <BaSeDatePicker
                              calendarType="months"
                              startDate={formAddExit.startMonth}
                              onStartDateChange={(e) =>
                                updateNewCreditNoStartMonth(e)
                              }
                              placeholder="Data de início"
                              label="Data inicial"
                              isDisabled={isDisabled}
                              minDate={formAddExitDefault.startMonth}
                            />
                          </>
                        )}
                      </div>

                      <div className="modal-fampe-area">
                        <h3>Operação com FAMPE?</h3>

                        <StepComponent
                          stepActive={stepFampe}
                          filterType={handleFampeChoice}
                          listSteps={StepsYesOrNot}
                        />

                        {isFampe ? (
                          <>
                            <FampeInputRange
                              isCustomInpRange={false}
                              value={formAddExit.pf}
                              setValue={(val) =>
                                setFormAddExit((prev) => ({ ...prev, pf: val }))
                              }
                              label="Qual a porcentagem de garantia FAMPE você gostaria de calcular?"
                            />

                            <div
                              className={`fampe-range-status ${
                                formAddExit?.pf == 80
                                  ? "fampe-80"
                                  : formAddExit?.pf > 80
                                    ? "fampe-over"
                                    : "fampe-under"
                              }`}
                            >
                              <h3>
                                O limite padrão de garantias do FAMPE é de 80%.
                              </h3>

                              {formAddExit?.pf == 80 && (
                                <p>
                                  Você tem grandes chances de conseguir o aval
                                  com esse valor.
                                </p>
                              )}

                              {formAddExit?.pf > 80 && (
                                <p>
                                  Situações excepcionais podem contemplar até
                                  100%. Verifique o seu enquadramento{" "}
                                  <strong>
                                    <a
                                      href="https://sebrae.com.br/sites/PortalSebrae/fampe"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      aqui
                                    </a>
                                  </strong>
                                  .
                                </p>
                              )}

                              {formAddExit?.pf < 80 && (
                                <p>
                                  Tem certeza de que deseja um valor menor?
                                  Verifique se essa opção atende às suas
                                  necessidades.
                                </p>
                              )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      {Object.values(calculatedValues).some(
                        (v) => Number(v) > 0
                      ) ? (
                        <div className="values-area">
                          <div className="main-value">
                            <div className="bg-img">
                              <img src={Calendar} alt="" />
                            </div>
                            <div>
                              <h3>Valor das parcelas</h3>
                              <p>R$ {formatCurrency(calculatedValues.val)}</p>
                            </div>
                          </div>
                          <div className="other-values">
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={CashBill}
                                  height={16}
                                  width={16}
                                  alt="Ícone de cédula"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>Valor Final Emprestado</h3>
                                <p>R$ {formatCurrency(calculatedValues.vfe)}</p>
                              </div>
                            </div>
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={DollarSign}
                                  height={16}
                                  width={16}
                                  alt="Ícone de cifrão"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>Valor Final Pago</h3>
                                <p>R$ {formatCurrency(calculatedValues.vfp)}</p>
                              </div>
                            </div>
                          </div>
                          <div className="other-values">
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={Clock}
                                  height={16}
                                  width={16}
                                  alt="Ícone de relógio"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>Saldo Devedor após Carência</h3>
                                <p>
                                  R$ {formatCurrency(calculatedValues.sdpc)}
                                </p>
                              </div>
                            </div>
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={Percentage}
                                  className="percentage"
                                  height={10.67}
                                  width={10.67}
                                  alt="Ícone de porcentagem"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>Total de Juros Pagos</h3>
                                <p>R$ {formatCurrency(calculatedValues.tjp)}</p>
                              </div>
                            </div>
                          </div>
                          <div className="other-values">
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={BlueShakeHands}
                                  height={16}
                                  width={16}
                                  alt="Icone de mãos apertadas"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>Comissão Concessão Aval</h3>
                                <p>R$ {formatCurrency(calculatedValues.cca)}</p>
                              </div>
                            </div>
                            <div className="other-values-value">
                              <div className="bg-img">
                                <img
                                  src={BlueCard}
                                  height={16}
                                  width={16}
                                  alt="Ícone de um cartão azul"
                                />
                              </div>
                              <div className="other-values-value-text">
                                <h3>IOF</h3>
                                <p>
                                  R$ {formatCurrency(calculatedValues.ioft)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="modal-button-area">
                        <div className="modal-button-area-button">
                          <Button
                            isPrimary
                            disabled={isDisabled}
                            callback={() => {
                              if (!validateNewCreditNo()) return;
                              const actionType =
                                showModal.type === "edit" || editId
                                  ? "edit"
                                  : "post";
                              setNewCreditModalForm(true);
                              saveDialogAddExit(
                                "newCreditNo",
                                actionType,
                                null,
                                editId
                              );
                            }}
                          >
                            Salvar
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </ModalDefault>

          <ModalDefault
            show={showModal.status}
            title={
              showModal.type === "create"
                ? showModal.context === "vigente"
                  ? "Adicionar endividamento vigente"
                  : showModal.context === "newCredit"
                    ? "Adicionar crédito novo"
                    : "Adicionar saída"
                : "Editar saída"
            }
            classCustom="dialog-exists"
            callBackClose={() => {
              setShowModal({...showModal, status: false})
              eventTag(event?.name, event?.category, event?.action, `Fechar modal - ${showModal.type === "create"
                ? showModal.context === "vigente"
                  ? "Adicionar endividamento vigente"
                  : showModal.context === "newCredit"
                    ? "Adicionar crédito novo"
                    : "Adicionar saída"
                : "Editar saída"}`)
            }}
          >
            <Formik
              initialValues={form}
              onSubmit={() => saveDialogAddExit("vigenteOrYNC")}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <div
                    className={
                      "wrapper-input " +
                      (formAddExit?.title?.length
                        ? formAddExit?.title
                          ? "valid"
                          : "invalid"
                        : "")
                    }
                  >
                    <BaSeInput
                      color="default"
                      inputMode="text"
                      typeInput="text"
                      inputStatus={
                        formAddExit?.title?.length
                          ? formAddExit?.title
                            ? "valid"
                            : "invalid"
                          : ""
                      }
                      value={formAddExit?.title}
                      onChange={(e) => {
                        setFormAddExit({ ...formAddExit, title: e });
                      }}
                      isDisabled={isDisabled}
                      placeholder="Escolha um nome para a saída"
                      size="medium"
                      label="Nome da saída"
                      width="100%"
                    />
                  </div>
                  <div className="form-date">
                    <p className="description">
                      Período da saída
                      <span>
                        Selecione um mês inicial e um mês final ou a quantidade
                        de meses
                      </span>
                    </p>

                    <StepComponent
                      stepActive={stepActive}
                      filterType={changeTabs}
                      listSteps={StepsModal}
                    />

                    <div className="date">
                      <div className={"inputs " + calendarType}>
                        {calendarType === "months" && (
                          <div className="wrapper-select">
                            <BaSeOptionPicker
                              label="Quantidade de meses"
                              placeholder="teste"
                              searchPlaceholder="Busca pelo nome"
                              values={periods()}
                              maxOptionsSelected={1}
                              initialSelectedValuesId={[
                                formAddExit?.numberOfMonths,
                              ]}
                              emptyValueLabel="Selecione uma opção"
                              onChange={(values) => {
                                updateStartEndDate(
                                  "select",
                                  values.map((val) => val.id)[0]
                                );
                              }}
                              isDisabled={isDisabled}
                            />
                          </div>
                        )}
                        <div className="wrapper-date">
                          <BaSeDatePicker
                            calendarType="months"
                            startDate={formAddExit.startMonth}
                            onStartDateChange={(e) =>
                              updateStartEndDate("start", e)
                            }
                            placeholder="Data de início"
                            label="Data inicial"
                            isDisabled={isDisabled}
                            minDate={formAddExitDefault.startMonth}
                          />
                          {calendarType === "days" && (
                            <BaSeDatePicker
                              calendarType="months"
                              startDate={formAddExit.endMonth}
                              onStartDateChange={(e) =>
                                updateStartEndDate("end", e)
                              }
                              placeholder="Data de término"
                              minDate={formAddExit.startMonth}
                              maxDate={
                                formAddExit.startMonth
                                  ? addMonths(
                                    new Date(formAddExit.startMonth),
                                    120
                                  )
                                  : undefined
                              }
                              label="Data final"
                              isDisabled={isDisabled || !formAddExit.startMonth}
                            />
                          )}
                        </div>
                      </div>
                      <div className="additional-month">
                        {formAddExit.fields.map((field, index) => {
                          return (
                            <div
                              key={`${index}-${field.label}`}
                              className="currency"
                            >
                              <BaSeInput
                                color="default"
                                inputMode="tel"
                                typeInput="tel"
                                inputStatus={
                                  field.val === 0
                                    ? undefined
                                    : validateCurrency(field.val)
                                      ? "invalid"
                                      : "valid"
                                }
                                value={field.val}
                                onChange={(e) => updateField(index, e)}
                                isDisabled={isDisabled}
                                placeholder="R$"
                                maxLength={22}
                                prefix="R$ "
                                mask="decimal"
                                size="medium"
                                label={field.label.replace("-", "/")}
                                width="100%"
                              />
                            </div>
                          );
                        })}
                      </div>
                      <BaSeCheckbox
                        key={formAddExit.different}
                        disabled={
                          isDisabled ||
                          (calendarType === "months"
                            ? !formAddExit.startMonth
                            : !formAddExit.startMonth ||
                            !formAddExit.endMonth ||
                            areDatesEqualIgnoringTime(
                              formAddExit?.startMonth,
                              formAddExit?.endMonth
                            ))
                        }
                        label="Valores diferentes"
                        shape="square"
                        size="small"
                        checked={formAddExit.different}
                        onChange={(e) =>
                          setFormAddExit({ ...formAddExit, different: e })
                        }
                      />
                      <div className="wrapper-button">
                        <button
                          type="button"
                          disabled={isDisabled}
                          onClick={() => {
                            if (!validateVigenteOrYNC()) return;
                            const actionType =
                              showModal.type === "edit" || editId
                                ? "edit"
                                : "post";
                            saveDialogAddExit(
                              "vigenteOrYNC",
                              actionType,
                              null,
                              editId
                            );
                          }}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalDefault>

          <ModalDefault
            show={initialBalance}
            title="Adicionar saldo inicial"
            classCustom="add-initial-balance"
            callBackClose={() => {
              setInitialBalance(false)
              eventTag(event?.name, event?.category, event?.action, "Fechar modal - Adicionar saldo inicial")
            }}
          >
            <Formik initialValues={form} onSubmit={() => addBalanceInitial()}>
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="form-initial-values">
                    <p className="description">Período do saldo</p>

                    <div className="wrapper-date">
                      <BaSeDatePicker
                        calendarType="months"
                        startDate={firstDayOfMonth(form?.mesBase)}
                        onStartDateChange={(e) => {
                          setForm((prevForm) => ({
                            ...prevForm,
                            mesBase: e,
                          }));
                        }}
                        placeholder="Data de início"
                        label="Data inicial"
                        isDisabled={isDisabled}
                        minDate={firstDayOfMonth(new Date())}
                      />
                    </div>
                    <div className="currency">
                      <BaSeInput
                        color="default"
                        inputMode="tel"
                        typeInput="tel"
                        defaultValue={0}
                        inputStatus={
                          validateCurrency(form.saldoInicial)
                            ? "invalid"
                            : "valid"
                        }
                        value={form.saldoInicial}
                        onChange={(e) => {
                          if (e.replace(".", "") === "000") {
                            setForm({
                              ...form,
                              saldoInicial: 0,
                            });
                          } else {
                            setForm({
                              ...form,
                              saldoInicial: e,
                            });
                          }
                        }}
                        isDisabled={isDisabled}
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Valor do saldo inicial"
                        width="100%"
                      />
                    </div>
                    <div className="wrapper-button">
                      <button
                        disabled={
                          isDisabled || !form.saldoInicial || !form.mesBase
                        }
                        type="submit"
                        onClick={() => handleSubmit}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalDefault>

          <Dialog
            show={showDialogConfirm}
            title="Atenção!"
            description={`
                Você está prestes a alterar o mês inicial do seu fluxo projetado. Todos os registros de saída que não estiverem dentro de 120 meses a partir do mês inicial serão excluídos. <br /><br />
                Deseja continuar?
              `}
            btnCancel="Cancelar"
            btnConfirm="Confirmar"
            onHide={() => {
              setShowDialogConfirm(false)
              eventTag(event?.name, event?.category, event?.action, "Fechar modal - Confirmação de alteração do mês inicial")
            }}
            callbackCancel={() => setShowDialogConfirm(false)}
            callbackConfirm={() => confirmChangeBalanceInitial()}
          />

          <div className="cash-flow__wrapper">
            <Slider
              className={
                "SettingsSliderCashFlow" +
                (!dataContent?.saidas.length ? " empty" : "")
              }
              {...SettingsSliderCashFlow}
            >
              <div className="wrapper-flux">
                <h3
                  className={dataContent.saldoInicial > 0 ? "has-balance" : ""}
                >
                  Fluxo de caixa projetado
                </h3>
                <div className="horizontal-bar" />
                <span
                  className={
                    "card-flux balance" +
                    (dataContent.saldoInicial > 0 ? " has-balance" : "") +
                    (showDetailsCashFlow ? " expanded" : " collapsed")
                  }
                >
                  <div className="header">
                    <div
                      className="icon-arrow"
                      onClick={() => setShowDetailsCashFlow((prev) => !prev)}
                    >
                      <img
                        src={showDetailsCashFlow ? ArrowUp : ArrowDown}
                        alt="seta"
                      />
                    </div>

                    <div className="header-content">
                      Saldo inicial em caixa
                      <BaSeIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          setInitialBalance(true);
                          eventTag(event?.name, event?.category, event?.action, "Saldo inicial em caixa")
                        }}
                        color={
                          dataContent.saldoInicial > 0 ? "#243342" : "#2e5de6"
                        }
                        description="Menu"
                        name={
                          dataContent.saldoInicial > 0
                            ? "design/pencil-line"
                            : "plus-square"
                        }
                        size={dataContent.saldoInicial > 0 ? 20 : 24}
                      />
                    </div>
                  </div>

                  {showDetailsCashFlow &&
                    (dataContent.saidas.length > 0 ||
                      dataContent.saldoInicial > 0) && (
                      <div className="has-balance">
                        {dataContent.saidas ? (
                          <p>Período: {getPeriodString(dataContent.saidas)}</p>
                        ) : (
                          ""
                        )}
                        {dataContent.saldoInicial > 0 ? (
                          <p>
                            Valor: R$ {formatCurrency(dataContent.saldoInicial)}
                          </p>
                        ) : (
                          <p>Valor: Não informado</p>
                        )}
                      </div>
                    )}
                </span>
                <span className="card-flux">Entradas (Lucro)</span>
                <div className="exits">
                  <div className="card-flux">
                    <div className="content">
                      <div
                        className={
                          "title " +
                          (!dataContent.saidas.length ? "mb-0 " : "") +
                          (showDetailsOutput
                            ? "title-expanded"
                            : "title-collapsed")
                        }
                      >
                        {dataContent.saidas.length > 0 && (
                          <img
                            src={showDetailsOutput ? ArrowUp : ArrowDown}
                            onClick={() =>
                              setShowDetailsOutput((prev) => !prev)
                            }
                            alt="seta"
                          />
                        )}
                        <div className="title-right">
                          Saídas
                          <BaSeIcon
                            onClick={() => {
                              setShowOptionsModal(true)
                              eventTag(event?.name, event?.category, event?.action, "Saídas +")
                            }}
                            color="#2e5de6"
                            description="Menu"
                            name="plus-square"
                            size={24}
                          />
                        </div>
                      </div>
                      <div className="title-values">
                        {dataContent?.saidas.length && showDetailsOutput
                          ? extractSections(dataContent).map((item) => {
                            return (
                              <React.Fragment key={item.sectionId}>
                                {deletingId === item.id ? (
                                  <div className="title-exits">
                                    <p>
                                      {(item.title || "Saída").length > 19
                                        ? (item.title || "Saída").slice(
                                        0,
                                        19
                                      ) + "..."
                                        : item.title || "Saída"}
                                    </p>
                                    <Loading small />
                                  </div>
                                ) : (
                                  <div className="title-exits">
                                    <p>
                                      {(item.title || "Saída").length > 19
                                        ? (item.title || "Saída").slice(
                                        0,
                                        19
                                      ) + "..."
                                        : item.title || "Saída"}
                                    </p>
                                    <div
                                      className={`action-buttons ${
                                        isDisabled ? "is-disabled" : ""
                                      }`}
                                    >
                                      <BaSeIcon
                                        color="#243342"
                                        description="Edit"
                                        name="design/pencil-line"
                                        size={20}
                                        onClick={() =>
                                          protectWhileDeleting(() => {
                                              openDialogForEdit(
                                                item.sectionId,
                                                item.id
                                              )
                                              eventTag(event?.name, event?.category, event?.action, "Editar saída")
                                            }
                                          )
                                        }
                                      />
                                      <BaSeIcon
                                        color="#243342"
                                        description="Trash"
                                        name="trash-alt"
                                        size={20}
                                        onClick={() => {
                                          if (isDisabled) return;
                                          protectWhileDeleting(() => {
                                              removeExitsById(
                                                item.sectionId,
                                                item.id,
                                                item.type
                                              )
                                              eventTag(event?.name, event?.category, event?.action, "Remover saída")
                                            }
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  className={
                    "card-flux capacity card-flux-gray " +
                    (results?.fluxgraph?.length ? "active" : "")
                  }
                >
                  Capacidade mensal de pagamento
                </span>
              </div>
              {dataContent?.saidas.length
                ? reorderEntriesBySections(
                  extractSections(dataContent),
                  dataContent?.saidas,
                  typeMap
                )
                  .reduce((acc, item, index) => {
                    const shouldInclude = filterExit.length
                      ? item.mes === filterExit
                      : true;
                    if (!shouldInclude) return acc;

                    const sumTotalSaidas = item.entries.reduce(
                      (acc, exits) => acc + exits.val,
                      0
                    );

                    const getFluxgraph = Array.isArray(
                      fluxgraphUpdated?.fluxgraph
                    )
                      ? fluxgraphUpdated.fluxgraph.find(
                        (graph) => graph.mes === item.mes
                      )
                      : null;

                    acc.push({
                      item,
                      index,
                      sumTotalSaidas,
                      getFluxgraph,
                    });

                    return acc;
                  }, [])
                  .map(({ item, index, sumTotalSaidas, getFluxgraph }) => {
                    return (
                      <div
                        key={index}
                        className="wrapper-flux dynamic"
                        id={item.mes}
                      >
                        <h3 className="gradient">
                          {index + 1} - {formatYearMonthToFullDate(item.mes)}
                        </h3>
                        <div className="horizontal-bar without-border" />
                        <span
                          className={
                            "card-flux balance small" +
                            (dataContent.saldoInicial > 0
                              ? " has-balance"
                              : "") +
                            (showDetailsCashFlow ? " expanded" : " collapsed")
                          }
                        >
                            R$ {formatCurrency(getFluxgraph?.saldo)}
                          </span>
                        <span className="card-flux">
                            R$ {formatCurrency(results?.l)}
                          </span>
                        <div className="exits wrapper-card">
                          <div
                            className={
                              "card-flux" +
                              (showDetailsOutput
                                ? " output-open"
                                : " output-closed")
                            }
                          >
                            <p className="card-flux__strong">
                              R$ {formatCurrency(sumTotalSaidas)}
                            </p>
                          </div>
                          {showDetailsOutput &&
                            item.entries.map((val) => (
                              <div
                                key={val.uuid}
                                className={
                                  "card-flux small"
                                }
                              >
                                {/* Essa lógica abaixo precisará do retorno do backend se o contexto é Vigente ou Crédito Novo */}
                                {/* Será feita na integração */}
                                <div className="card-flux-value">
                                  {val?.type === "credito-novo-sim" ||
                                  val?.type === "credito-novo-nao" ? (
                                    <img src={Wallet} alt="" />
                                  ) : (
                                    <img src={MoneyBox} alt="" />
                                  )}
                                  <p>R$ {formatCurrency(val?.val)}</p>
                                </div>
                              </div>
                            ))}
                        </div>
                        <span
                          className="card-flux capacity card-flux-gray active"
                          style={{
                            backgroundColor:
                              getFluxgraph?.capacidadeMensal < 0
                                ? "#F28A8E"
                                : "#CfE2FC",
                            color:
                              getFluxgraph?.capacidadeMensal < 0
                                ? "#bf303c"
                                : "#2e5de6",
                          }}
                        >
                            R$ {formatCurrency(getFluxgraph?.capacidadeMensal)}
                          </span>
                      </div>
                    );
                  })
                : ""}
            </Slider>
          </div>
          <TemplateQuickView />
        </>
      )}
    </div>
  );
};

export default ProjectedCashFlow;
